<template>
  <div class="root-app">
    <div
      id="my-wallet-container"
      class="grid-x my-wallet-home-container align-center"
      :class="{ 'promotion-offers': route.path == '/shop/coupons-deals' }"
    >
      <div class="grid-x my-wallet-home padding-bottom-s">
        <div v-if="showLeftNavAndBreadcrumb()" class="cell large-3 show-for-large lfn-container">
          <LeftNav />
        </div>

        <div v-if="headerLoader" :class="['cell', showLeftNavAndBreadcrumb() ? 'large-9' : 'large-12']">
          <slot></slot>
        </div>
        <div v-else :class="['cell small-12', couponDeals ? 'large-9' : 'large-12']">
          <div v-if="couponDeals">
            <div class="custom-skeleton">
              <AtomicUiSkeleton width="5%" />
              <br />
              <AtomicUiSkeleton width="70%" />
            </div>
            <br />
            <SingleSkeleton />
            <br />
            <offers-skeleton title="Payment Methods" />
            <br />
            <offers-skeleton title="Saved Offers & passes" />
          </div>
        </div>
      </div>
    </div>
    <!--    <div v-if="footerLoader">
      <SingleSkeleton />
    </div>
    <div v-else>-->
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useWalletStore } from '../stores/wallet';
import { useEnvPropsStore } from '../stores/envProps';
import { loadTagLibrary, fireTag } from '@vue-util/tagManager';
import sessionTimeOutHandler from '../utils/interceptors/SessionTimeOutHandler';
import LeftNav from '../components/LeftNav.vue';
import OffersSkeleton from '../components/common/skeletons/OffersSkeleton.vue';
import SingleSkeleton from '../components/common/skeletons/SingleSkeleton.vue';
import requestInterceptor from '../utils/interceptors/PersistentLoginRequestInterceptor';
import { ExperimentationTags } from '@vue-util/experimentation';
import { Cookie } from '@vue-util/cookie';

const walletStore = useWalletStore();
const envPropsStore = useEnvPropsStore();
const route = useRoute();
const { envProps } = storeToRefs(envPropsStore);

const footerLoader = ref(true);
const headerLoader = ref(false);
const appMounted = ref(false);
const alreadyProcessed = useState('rewardCardProcessed', () => false);
const couponDeals = computed(() => route.name !== 'promotionoffers');

onMounted(async () => {
  window.medalliaSurveyData = 'in My Wallet';

  if (alreadyProcessed.value) return;
  alreadyProcessed.value = true;
  await callRewardCard();
  const entryPoint = envProps.value?.entryPoint;
  const tagManger = envProps.value?.tagMngrEnv;
  loadTagLibrary(entryPoint, tagManger, true);

  setTimeout(() => {
    footerLoader.value = false;
    headerLoader.value = true;
  }, 1000);

  if (route.path === '/shop/coupons-deals') {
    fireTag('view', {
      page_name: 'mcom:deals and promotions',
      page_type: 'deals and promotions',
    });
  } else {
    fireTag('view', {
      page_name: 'mcom:my account:wallet',
      page_type: 'wallet',
    });
  }

  if (envProps?.value.killswitches?.persistentLoginEnabled && envProps?.value?.killswitches?.persistentLoginForWalletPageEnabled) {
    requestInterceptor();
  }

  sessionTimeOutHandler();

  appMounted.value = true;

  ExperimentationTags.fireAdobeTags();
});

function showLeftNavAndBreadcrumb() {
  const hiddenRoutes = ['printPromotionalGiftCard', 'promotionoffers'];
  return !hiddenRoutes.includes(route.name);
}

async function callRewardCard() {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const userguid = Cookie.get('macys_online_guid');
    const secureUserToken = Cookie.get('secure_user_token');
    const param = {
      cardguid: urlParams.get('cg'),
      userguid: userguid,
      secureUserToken: secureUserToken,
    };
    if (urlParams.get('cg')) {
      await walletStore
        .addRewardCard(param)
        .then(() => {})
        .catch(() => {});
    }
  }
}
</script>
<style lang="scss">
@import '@core/csg/src/scss/settings/bcom.scss';

.root-app {
  @include breakpoint(small only) {
    #my-wallet-container {
      padding: rem-calc(0 20 0 20);
    }
  }

  .my-wallet-home-container {
    .my-wallet-home {
      margin: 0 auto !important;
      max-width: rem-calc(1601);
      width: 100%;
      padding: rem-calc(68 32 0 32);

      @include breakpoint(small only) {
        padding: rem-calc(0);
      }
    }
  }
}

.skeleton-cell {
  width: 33%;
  float: left;
  padding: rem-calc(2);
}

.promotion-offers {
  background: #eeeeee;
}

@media only screen and (max-width: rem-calc(600)) {
  .my-wallet-home {
    margin: rem-calc(0) !important;
  }

  .promotion-offers {
    width: rem-calc(500) !important;

    .my-wallet-home {
      width: 95% !important;
      padding: rem-calc(0) !important;
    }
  }
}

@media only screen and (max-width: rem-calc(400)) {
  .promotion-offers {
    width: rem-calc(390) !important;

    .my-wallet-home {
      width: 95% !important;
      padding: rem-calc(0) !important;
    }
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
.grey-text {
  color: $gray-1-color;
}

.grid-x > .small-12 {
  width: 100%;
  padding-bottom: rem-calc(10) !important;
}
</style>
